import { Icon, InputAdornment, Link, TextField } from "@mui/material";
import { MaskedField } from "components/fields";
import { format } from "date-fns";
import { parseINN } from "utils/inn";
import { IDriverRequest } from "./types";
import AtpCallButton from "./atpCallButton";

type IFields = { [type in (keyof IDriverRequest)]: {
  title: string;
  field: (v: any, onChange: (v: any) => void, id?: number) => JSX.Element | null
} }

export const FIELDS: IFields = {
  id: {
    title: 'ID',
    field: (v, onChange) => null
  },
  created: {
    title: 'Дата створення',
    field: (v, onChange) => null
  },
  updated: {
    title: 'Дата останнього оновлення',
    field: (v, onChange) => null
  },
  full_name: {
    title: 'ПІБ',
    field: (v, onChange) => (
      <TextField
        label={`${FIELDS.full_name.title}*`}
        margin="none"
        value={v || ''}
        onChange={onChange}
        disabled={true}
      />
    )
  },
  phone: {
    title: 'Телефон',
    field: (v, onChange, id) => (
      <MaskedField
        label={`${FIELDS.phone.title}*`}
        mask="+38 (099) 999 99 99"
        margin="none"
        value={v || ''}
        onChange={onChange}
        disabled={true}
        InputProps={{
          sx: {
            pr: 0
          },
          endAdornment: v ? (
            <InputAdornment position='end'>
              <AtpCallButton
                id={id}
                phone={v}
              />
            </InputAdornment>
          ) : undefined
        }}
      />
    )
  },
  email: {
    title: 'E-mail',
    field: (v, onChange) => (
      <TextField
        label={FIELDS.email.title}
        margin="none"
        value={v || ''}
        onChange={onChange}
        disabled={true}
      />
    )
  },
  inn: {
    title: 'ІПН',
    field: (v, onChange) => {
      let helpText = null;
      if (v) {
        const inn = parseINN(v);
        if (inn) {
          helpText = `Дата народження: ${format(inn.date_of_birth, "dd.MM.yyyy")} (${inn.age})`;
        }
      }
      return (
        <TextField
          label={FIELDS.inn.title}
          margin="none"
          value={v || ''}
          helperText={helpText}
          onChange={onChange}
          disabled={true}
        />
      )
    }
  },
  car_model: {
    title: 'Марка та модель авто',
    field: (v, onChange) => (
      <TextField
        label={FIELDS.car_model.title}
        margin="none"
        value={v || ''}
        onChange={onChange}
        disabled={true}
      />
    )
  },
  car_state_number: {
    title: 'Держ. номер авто',
    field: (v, onChange) => {
      let helpText = (
        <Link
          href={"https://ua.carplates.app/number/" + (v || '').replace(/ /g, "")}
          target="_blank"
          rel="noreferrer"
        >
          Перевірити на carplates.app <Icon fontSize="inherit">open_in_new</Icon>
        </Link>
      )
      return (
        <TextField
          label={FIELDS.car_state_number.title}
          margin="none"
          value={v || ''}
          onChange={onChange}
          helperText={v ? helpText : null}
          disabled={true}
        />
      )
    }
  },
  car_year: {
    title: 'Рік випуску авто',
    field: (v, onChange) => (
      <TextField
        label={FIELDS.car_year.title}
        margin="none"
        value={v || ''}
        onChange={onChange}
        disabled={true}
      />
    )
  },
  driving_experience: {
    title: 'Водійський досвід',
    field: (v, onChange) => (
      <TextField
        label={FIELDS.driving_experience.title}
        margin="none"
        value={v || ''}
        onChange={onChange}
        disabled={true}
      />
    )
  },
  last_status_request: {
    title: 'Статус',
    field: (v, onChange) => null
  },
}